import React from 'react';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center justify-center w-16 h-16 rounded-xl shadow-card overflow-hidden">
          <img 
            src="/assets/images/logoGuardia-1756232511900.png" 
            alt="Guardia Nacional - Justicia y Paz" 
            className="w-full h-full object-contain"
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-foreground">
          Vehicle Scanner
        </h1>
        <p className="text-sm text-muted-foreground font-mono">
          Sistema de Monitoreo Vehicular
        </p>
      </div>
      
      <div className="mt-6 mb-2">
        <h2 className="text-xl font-medium text-foreground">
          Iniciar Sesión
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Accede a tu panel de control de monitoreo
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;